<template>
  <div class="form-group">
    <label for="broker">{{ label }}</label>
    <select class="form-control" id="broker" name="broker" @change="onChange">
      <option disabled selected></option>
      <option v-if="hasPinnedBrokerDealers" v-for="brokerDealer in pinnedBrokerDealers" :key="brokerDealer.id" :value="brokerDealer.id">
        {{ brokerDealer.name }}
      </option>
      <option v-if="hasPinnedBrokerDealers" disabled>----------</option>
      <option v-if="noBrokerDealer" :value="noBrokerDealer.id">{{ noBrokerDealer.name }}</option>
      <option v-if="noBrokerDealer" disabled>----------</option>
      <option v-for="brokerDealer in sortedBrokerDealers" :key="brokerDealer.id" :value="brokerDealer.id">
        {{ brokerDealer.name }}
      </option>
      <option v-if="otherBrokerDealer" disabled>----------</option>
      <option v-if="otherBrokerDealer" :value="otherBrokerDealer.id">{{ otherBrokerDealer.name }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'registration-form-broker-dealer',
  props: {
    brokerDealers: {
      type: Array,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  computed: {
    noBrokerDealer() {
      return this.brokerDealers.find(dealer => dealer.name === 'Not Applicable / Not Associated with a Broker Dealer');
    },
    otherBrokerDealer() {
      return this.brokerDealers.find(dealer => dealer.name === 'Other / Not Listed');
    },
    pinnedBrokerDealers() {
        const excludedIds = [
            this.noBrokerDealer && this.noBrokerDealer.id,
            this.otherBrokerDealer && this.otherBrokerDealer.id,
        ].filter(Boolean);

        return this.brokerDealers.filter(dealer => dealer.is_pinned_to_top === true && !excludedIds.includes(dealer.id));
    },
    hasPinnedBrokerDealers() {
      return this.pinnedBrokerDealers.length > 0;
    },
    sortedBrokerDealers() {
      const excludedIds = [
        this.noBrokerDealer && this.noBrokerDealer.id,
        this.otherBrokerDealer && this.otherBrokerDealer.id,
      ].filter(Boolean);

      return this.brokerDealers.filter(dealer => dealer.is_pinned_to_top === false && !excludedIds.includes(dealer.id));
    },
  },
  methods: {
    onChange(event) {
      this.$emit('input', event.target.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
